import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { version } from '../../package.json';

@Component({
    selector: 'cw-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    public config = environment;

    constructor(private titleService: Title) {
    }

    ngOnInit() {
        console.log('\x1b[32m%s\x1b[0m', `Publisher Panel is up and running on ${version} version.`);
        this.titleService.setTitle(this.config.name);
    }

}
